export default __webpack_public_path__ + "static/media/balance.a8031af2.png";